"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserResource = function () {
  function UserResource($http) {
    (0, _classCallCheck3.default)(this, UserResource);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      LOGIN: "auth/login/",
      LOGOUT: "auth/logout/",
      ME: "auth/user/",
      CONFIRM_EMAIL: "auth/verify-email/",
      RESET_PASSWORD: "auth/password/reset/",
      RESET_PASSWORD_CONFIRM: "auth/password/reset/confirm/",
      CHANGE_PASSWORD: "auth/password/change/",
      UPDATE: "auth/user/"
    };
  }

  (0, _createClass3.default)(UserResource, [{
    key: "login",
    value: function login(email, password) {
      return this.$http.post(this.PATH.LOGIN, {
        email: email,
        password: password
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      return this.$http.post(this.PATH.LOGOUT);
    }
  }, {
    key: "me",
    value: function me() {
      return this.$http.get(this.PATH.ME);
    }
  }, {
    key: "update",
    value: function update(data) {
      return this.$http.patch(this.PATH.UPDATE, data);
    }
  }, {
    key: "switchAccount",
    value: function switchAccount(account) {
      return this.$http.patch(this.PATH.UPDATE, { "active_account_id": account.id });
    }
  }, {
    key: "setTimezone",
    value: function setTimezone(timezone) {
      return this.$http.patch(this.PATH.UPDATE, { "timezone": timezone });
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(email) {
      return this.$http.post(this.PATH.RESET_PASSWORD, { "email": email });
    }
  }, {
    key: "confirmEmail",
    value: function confirmEmail(key) {
      return this.$http.post(this.PATH.CONFIRM_EMAIL, { "key": key });
    }
  }, {
    key: "resetPasswordConfirm",
    value: function resetPasswordConfirm(data) {
      return this.$http.post(this.PATH.RESET_PASSWORD_CONFIRM, data);
    }
  }, {
    key: "changePassword",
    value: function changePassword(data) {
      return this.$http.post(this.PATH.CHANGE_PASSWORD, data);
    }
  }]);
  return UserResource;
}();

exports.default = UserResource;


//////////////////
// WEBPACK FOOTER
// ./src/api/UserResource.js
// module id = 329
// module chunks = 0